import React, { useEffect, useState } from "react";
import Preloader from "../../Shared/Preloader/Preloader";
import Sidebar from "../../Shared/Sidebar";
import LessSidebar from "../../Shared/LessSidebar";
import Navbar from "../../Shared/Navbar/Navbar";
import {
  Accordion,
  Button,
  Col,
  Form,
  FormControl,
  FormGroup,
  FormLabel,
  Modal,
  Row,
  Spinner,
  useAccordionButton,
} from "@themesberg/react-bootstrap";
import { PagesRoutes } from "../../../pages_routes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faExclamationTriangle,
  faFileMedical,
  faFolder,
  faHospital,
  faList,
  faListOl,
  faMoneyBill,
  faPhone,
  faPlusCircle,
  faSave,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { currentUser } from "../../../authentication/auth";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "../../../config/axios";
import { APIURL } from "../../../configApi";

// import "react-modern-calendar-datepicker/lib/DatePicker.css";
// import { Calendar } from "react-modern-calendar-datepicker";
import { fr } from "date-fns/locale";
import { format } from "date-fns";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import FirebaseNotif from "../../Shared/FirebaseNotif/FirebaseNotif";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
const SettingsAgent = () => {
  const navigate = useNavigate();
  const [launch_date, setLaunchDate] = useState();
  const [user, setUser] = useState();
  const [groupes, setGroupes] = useState();
  const [laboratoires, setLaboratoires] = useState([]);
  const [laboratoire_id, setLaboratoireID] = useState();
  const [update, setUpdate] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loadingSettings, setLoadingSettings] = useState(false);
  const handleClose = () => {
    // setShowPlanifier(false);
    // setShowDeleteGroupe(false);
    // setShowChangement(false);
  };
  useEffect(() => {
    if (currentUser() == null) {
      navigate("/login");
    } else {
      setUser(currentUser());
    }
    getGroupes(currentUser()?.parent_id);
    //getMyLabo();
  }, []);

  const getGroupes = (idLabo) => {
    setLoadingSettings(true);
    axiosInstance
      .get(`${APIURL}/global/settings/services/` + idLabo)
      .then((res) => {
        // console.log(res.data.data);
        setGroupes(res.data.data);
        setUpdate((prev) => prev + 1);
        setLoadingSettings(false);
      })
      .catch((err) => {
        // console.log(err);
        setLoadingSettings(false);
      });
  };

  const [hideSidebar, setHideSidebar] = useState(
    JSON.parse(localStorage.getItem("sidebar-state"))
  );
  const openInNewTab = (url) => {
    window.open(url, "_blank", "noreferrer");
  };
  return (
    <>
      <Preloader />
      <div className={`content`}>
        {hideSidebar ? (
          <LessSidebar
            user={user}
            expand={() => {
              setHideSidebar(false);
              localStorage.setItem("sidebar-state", false);
            }}
          />
        ) : (
          <Sidebar
            user={user}
            expand={() => {
              setHideSidebar(true);
              localStorage.setItem("sidebar-state", true);
            }}
          />
        )}
      </div>
      {/* <FirebaseNotif /> */}
      <main className={`content ${hideSidebar ? "mleft-0" : ""}`}>
        <Navbar user={user} />
        <hr />
        <div>
          <NotificationContainer />

          <div>
            {loading && (
              <div className="text-center">
                <Spinner animation="border" className="text-center" />
              </div>
            )}
          </div>
          <Row>
            <Col lg={"12"}>
              <div className={"card mb-2 p-4"}>
                <h3 className={"mb-3"}> Informations du laboratoire </h3>
                <div className={"d-flex justify-content-between"}>
                  <h4 className={"text-main"}>
                    <FontAwesomeIcon icon={faHospital} className={"me-2"} />
                    {user?.parent?.first_name +
                      ` ` +
                      user?.parent?.last_name}( {user?.parent?.city?.name} ){" "}
                  </h4>
                  <h4 className={"text-main"}>
                    <FontAwesomeIcon
                      icon={faWhatsapp}
                      className={"me-2 fs-5"}
                      onClick={() =>
                        openInNewTab(
                          `https://wa.me/+216${user?.parent?.principal_phone}`
                        )
                      }
                      role="button"
                    />
                    <FontAwesomeIcon icon={faPhone} className={"me-2"} />
                    {user?.parent?.principal_phone}{" "}
                  </h4>
                </div>
              </div>
            </Col>
          </Row>
          {loadingSettings ? (
            <div className="text-center mt-4">
              <Spinner animation="border" />
            </div>
          ) : (
            <div className="m-4">
              <Accordion defaultActiveKey={["0"]} alwaysOpen>
                {groupes && groupes.length > 0
                  ? groupes.map((g, index) => (
                      <Accordion.Item eventKey={index}>
                        <Accordion.Header>
                          <span className={"fw-bold"}>
                            <FontAwesomeIcon
                              icon={faFolder}
                              className={"me-2"}
                            />
                            {g.name.toUpperCase()}
                          </span>
                        </Accordion.Header>
                        <Accordion.Body>
                          <Accordion defaultActiveKey={["0"]} alwaysOpen>
                            {g.sub_groups.length > 0 &&
                              g.sub_groups.map((sg, indexSG) => (
                                <Accordion.Item eventKey={indexSG}>
                                  <Accordion.Header>
                                    <span className={"fw-bold"}>
                                      <FontAwesomeIcon
                                        icon={faListOl}
                                        className={"me-2"}
                                      />
                                      {sg.name.toUpperCase()}{" "}
                                    </span>{" "}
                                  </Accordion.Header>
                                  <Accordion.Body>
                                    <Accordion
                                      defaultActiveKey={["0"]}
                                      alwaysOpen
                                    >
                                      {sg.services.length > 0 &&
                                        sg.services.map((service, indexS) => (
                                          <Accordion.Item eventKey={indexS}>
                                            <Accordion.Header
                                              title={service.description}
                                            >
                                              <span className={"fw-bold"}>
                                                <FontAwesomeIcon
                                                  icon={faFileMedical}
                                                  className={"me-2"}
                                                />
                                                {service.name.toUpperCase()}
                                              </span>{" "}
                                            </Accordion.Header>
                                          </Accordion.Item>
                                        ))}
                                    </Accordion>
                                  </Accordion.Body>
                                </Accordion.Item>
                              ))}
                          </Accordion>
                        </Accordion.Body>
                      </Accordion.Item>
                    ))
                  : ""}
              </Accordion>
            </div>
          )}
        </div>
      </main>
    </>
  );
};

export default SettingsAgent;
